<template>
  <div class="rechargeBox">
    <ul class="rechargeTitle">
      <li v-for="(item,index) in rechargeTitle" :key="index" :class="index == stepIdx?'active':''">
        <img :src="item.icons" v-if="item.status" />
        <img :src="item.icon" v-else />
        {{index+1}}. {{item.name}}
      </li>
    </ul>
    <template v-if="stepIdx == 0">
      <ul class="rechargeList">
        <li>
            <div class="rechargeName">充值账号：</div>
            <input type="text" class="rechargeInput" v-model.trim="recharge.account" @input="accountInput" maxlength="30" placeholder="请输入充值账号"/>
        </li>
        <li>
            <div class="rechargeName">充值服务器：</div>
            <select class="rechargeInput rechargeSelect" v-model="recharge.serverId" placeholder="请选择充值服务器" >
              <option v-for="item in serverList" :key="item" :value="item">{{item}}</option>
            </select>
        </li>
        <li>
            <div class="rechargeName">充值金额：</div>
            <div class="selectList">
              <div class="selectLi" v-for="(item,index) in grades" :key="index" @click="amountBtn(item,index)" :class="index == gradesIdx?'selectActive':''">
                <img src="../images/recharge/select.png" class="selectImg" v-if="index == gradesIdx" alt="">
                <p>
                  <b>{{item.currency}}平台币</b>
                  <span>{{item.price}}元</span>
                </p>
              </div>
              <input type="number" v-model.number="customAmount" @click="selectBtn" @change="selectInput" @focus="selectInput" :class="isShowInput?'selectActive':''" class="selectInput" placeholder="自定义金额"  maxlength="7"/>
            </div>
        </li>
        <li>
            <div class="rechargeName">充值方式：</div>
            <div class="selectPay">
              <div class="payLi" v-for="(item,index) in defray" :key="index" @click="payBtn(item,index)" :class="index == recharge.payIdx?'selectActive':''">
                <img src="../images/recharge/select.png" class="selectImg" v-if="index == recharge.payIdx" alt="">
                <img :src="item.icon" class="payIcon" alt="" />
                <p>{{item.name}}</p>
              </div>
            </div>
        </li>
        <li>
            <div class="submitBtn" @click="submitBtn">提交</div>
        </li>
      </ul>
    </template>
    <template v-if="stepIdx == 2">
      <div class="statusBox">
        <img src="../images/recharge/status_err.png" alt="" class="statusImg" />
        <div class="rechargeStatus">充值失败</div>
        <div class="errorText"><b>提示：</b>本充值系统暂不开放</div>
        <div class="backPrBtn" @click="stepIdx = 0,rechargeTitle[0].status = true,rechargeTitle[2].status = false">返回上一步</div>
      </div>
    </template>
    <Tips ref="tipsLarey"/>
  </div>
</template>
<script>
import Tips from '../components/tips';
export default {
  name:'recharge',
  data() {
    return {
      stepIdx: 0,      // 步骤索引
      recharge:{
        account: '',    // 充值账号
        serverId: 'A',  // 充值服务器
        amount: '',     // 充值金额
        payIdx: -1,     // 支付索引
      },
      gradesIdx: -1,    // 金额索引
      customAmount: '', // 自定义金额
      isShowInput:false, // 是否添加input样式
      serverList: ['A','B','C','D','E','F'],
      rechargeTitle:[
        {
          icon: require('../images/recharge/step_1.png'),
          icons: require('../images/recharge/step_1_s.png'),
          status: true,
          name: '选择充值'
        },
        {
          icon: require('../images/recharge/step_2.png'),
          icons: require('../images/recharge/step_2_s.png'),
          status: false,
          name: '充值信息'
        },
        {
          icon: require('../images/recharge/step_3.png'),
          icons: require('../images/recharge/step_3_s.png'),
          status: false,
          name: '充值成功'
        },
      ],
      grades:[
        {
          currency: 10,
          price: 10,
        },
        {
          currency: 50,
          price: 50,
        },
        {
          currency: 100,
          price: 100,
        },
        {
          currency: 200,
          price: 180,
        },
        {
          currency: 500,
          price: 480,
        },
      ],
      defray:[
        {
          icon:require('../images/recharge/pay_1.png'),
          name:'支付宝'
        },
        {
          icon:require('../images/recharge/pay_2.png'),
          name:'微信支付'
        },
      ],
    }
  },
  methods:{
    
  },
  methods:{
    // 监听输入金额
    accountInput(){
      let str = /[^\w_]/g;
      if(str.test(this.recharge.account)){
        this.$refs.tipsLarey.tipsShow('只能为英文、数字、下划线');
      };
    },
    // 选择充值金额
    amountBtn(e,i){
      this.gradesIdx = i;
      this.recharge.amount = e.price;
      this.isShowInput = false;
    },
    // 选择输入-充值金额
    selectBtn(){
      this.gradesIdx = this.grades.length+1;
      this.isShowInput= true;
    },
    // 充值金额-input框
    selectInput(){
      this.recharge.amount = this.customAmount;
    },
    // 选择支付方式
    payBtn(e,i){
      this.recharge.payIdx = i;
    },
    // 提交-按钮
    submitBtn(){
      if(this.isPayMode()){
        this.rechargeTitle[this.stepIdx].status = false; 
        this.stepIdx += 2;
        this.rechargeTitle[this.stepIdx].status = true; 
        console.log('充值成功',this.recharge)
      }
    },
    // 判断是否输入/选择
    isPayMode(){
      if(this.recharge.account == ''){
        this.$refs.tipsLarey.tipsShow('请输入充值账号');
        return false;
      }else if(this.gradesIdx == -1){
        this.$refs.tipsLarey.tipsShow('请选择充值金额');
        return false;
      }else if(this.recharge.payIdx == -1){
        this.$refs.tipsLarey.tipsShow('请选择充值方式');
        return false;
      }else{
        return true;
      }
    },
  },
  components: {
    Tips
  },
}
</script>
<style lang="scss" scoped>

  .rechargeBox{
    min-height:800px;
    width:$navWidth;
    margin:20px auto 40px;
    border-radius: 5px;
    background:var(--colorFF);
  }
  .rechargeTitle{
    padding:0 5%;
    display: flex;
    background: var(--colorF5a);
    border-bottom: 3px solid var(--colorE7);
    li{
      width:(100%/3);
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
      padding:10px 20px 10px 0;
      @include h-fontSize(var(--colorC3),16px,40px);
      img{
        width:22px;
        margin-right:5px;
      }
      &:after{
        content: '';
        top:50%;
        right:0;
        width:30px;
        height:25px;
        position: absolute;
        @extend %placeY;
        @include h-bgContain('../images/recharge/arrow.png');
        background-position-x: center;
      }
      &:last-child{
        &:after{
          display: none;
        }
      }
    }
    .active{
      font-weight:bold;
      color:var(--color00);
    }
  }
  .rechargeList{
    width:100%;
    padding:70px 0 70px 10%;
    li{
      position: relative;
      padding:10px 0 25px 100px;
      .rechargeName{
        top:10px;
        left:0;
        position: absolute;
        @include h-fontSize(var(--color00),14px,44px);
      }
      .rechargeInput{
        width:50%;
        height:44px;
        border:none;
        text-indent: 15px;
        border-radius: 5px;
        background: var(--colorF5);
        @include h-fontSize(var(--color00),14px,44px);
        &::placeholder{
          font-size:13px;
          color: var(--color89);
        }
      }
      .rechargeSelect{
        appearance:none;  
        -moz-appearance:none;  
        -webkit-appearance:none;   
        font-size:16px;  
        outline:none;
        background: url("../images/recharge/arrow_dw.png") no-repeat var(--colorF5) 98% center; 
        background-size:18px;
        
      }
      .selectList{
        width: 60%;
        display: flex;
        flex-wrap: wrap;

        .selectInput,
        .selectLi{
          border:none;
          width:120px;
          height:70px;
          margin:0 20px 15px 0;
          display: flex;
          align-items: center;
          justify-content: center;
          text-align: center;
          background: var(--colorEb);
          position: relative;
          cursor: pointer;   
          transition: border, background 0.3s;        
          -webkit-transition: border, background 0.3s;
          @include h-fontSize(var(--color00),14px,24px);
          p,b,span{
            display: block;
          }
          span{
            color:var(--color66);
            line-height:20px;
          }
          .selectImg{
            top:0;
            right:0;
            width:20px;
            position: absolute;
          }
        }           
        .selectInput{
          outline:0;
          text-align: center;
        }
        // .selectInput:focus,
        // .selectInput:valid{
	      //   background: $colorFF;
        //   border:2px solid $colorE7;
        // }
        .selectActive{
          background: var(--colorFF);
          color:var(--colorE7);
          border:2px solid var(--colorE7);
        }
        .selectInput{
          cursor:auto;
          @include h-fontSize(var(--color00),14px,44px);
        }
      }
      .selectPay{
        display: flex;
        .payLi{
          width:140px;
          margin-right:20px;
          display: flex;
          cursor: pointer;
          position: relative;
          align-items: center;
          justify-content: center;
          border-radius: 3px;
          border:1px solid var(--colorF3);
          transition: border 0.3s;        
          -webkit-transition: border 0.3s;
          @include h-fontSize(var(--color00),14px,48px);
          .selectImg{
            top:0;
            right:0;
            width:20px;
            position: absolute;
          }
          .payIcon{
            width:28px;
            height:28px;
            margin-right:5px;
          }
        }
        .selectActive{
          background: var(--colorFF);
          border:1px solid var(--colorE7);
        }
      }
      .submitBtn{
        cursor: pointer;
        margin:20px 0 0;
        transition: background 0.3s;
        -webkit-transition: background 0.3s;
        @include h-btn(280px, 52px, 16px, var(--colorFF), 4px, 0, var(--colorF6), false,none);
        &:hover{
          background: var(--colorE7);
        }
      }
    }
  }
  .statusBox{
    padding: 15% 0 0;
    text-align: center;
    .statusImg{
      margin:0 auto;
      width:100px;
    }
    .rechargeStatus{
      margin:15px auto 10px;
      font-weight:bolder;
      @include h-fontSize(var(--color00),24px,30px);
    }
    .errorText{
      @include h-fontSize(var(--color33),16px,24px);
    }
    .backPrBtn{
      cursor: pointer;
      margin:20px auto 0;
      transition: background 0.3s;
      -webkit-transition: background 0.3s;
      @include h-btn(110px, 32px, 12px, var(--colorFF), 2px, 0, var(--colorF6), false,none);
      &:hover{
        background: var(--colorE7);
      }
    }
  }
</style>
